import { render, staticRenderFns } from "./EnrollmentDetailsModal.vue?vue&type=template&id=3468c640&"
import script from "./EnrollmentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./EnrollmentDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports